<template>
  <div class="form-group position-relative" :class="label ? 'labelled' : ''">
    <label v-if="label" :for="id">{{ label }}</label>

    <div class="soft-field-group" :class="{ 'has-password-toggle': isPassword }">
      <Field
        v-model="internalValue"
        :id="id"
        :type="displayType"
        class="form-control"
        :class="[getClasses(size, success, error), inputClasses, { 'soft-field-password': isPassword }]"
        :name="name"
        :placeholder="placeholder"
        :required="isRequired"
        :maxlength="largo"
        :readonly="readonly"
        :min="min"
        :max="max"
        :step="inputStep"
        :inputmode="inputMode"
      />
      <button
        v-if="isPassword"
        type="button"
        class="soft-field-toggle"
        :aria-label="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
        :aria-pressed="showPassword ? 'true' : 'false'"
        @click="togglePassword"
        @mouseleave="hidePassword"

      >
        <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
      </button>
    </div>

    <ErrorMessage
      :name="name"
      class="error-feedback text-xs text-danger"
      role="alert"
    />
  </div>
</template>

<script>
import { Field, ErrorMessage } from "vee-validate";
export default {
  name: "SoftField",
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    size: {
      type: String,
      default: "default",
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    placeholder: {
      type: String,
      default: "...",
    },
    label: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    largo: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    min: {
      type: [String, Number],
      default: null,
    },
    max: {
      type: [String, Number],
      default: null,
    },
    step: {
      type: [String, Number],
      default: null,
    },
    decimales: {
      type: [String, Number],
      default: null,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      showPassword: false,
    };
  },
  methods: {
    getClasses: (size, success, error) => {
      let sizeValue, isValidValue;

      sizeValue = size ? `form-control-${size}` : null;

      if (error) {
        isValidValue = "is-invalid";
      } else if (success) {
        isValidValue = "is-valid";
      } else {
        isValidValue = "";
      }

      return `${sizeValue} ${isValidValue}`;
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    hidePassword() {
      this.showPassword = false;
    },
  },
  computed: {
    decimalPlaces() {
      const parsed = Number(this.decimales);

      return Number.isInteger(parsed) && parsed >= 0 ? parsed : null;
    },
    inputType() {
      return this.type === "amount" ? "number" : this.type;
    },
    isPassword() {
      return this.type === "password";
    },
    displayType() {
      if (this.isPassword) {
        return this.showPassword ? "text" : "password";
      }

      return this.inputType;
    },
    inputStep() {
      if (this.step !== null && this.step !== "") {
        return this.step;
      }

      if (this.type === "amount") {
        return "0.01";
      }

      if (this.decimalPlaces !== null) {
        return this.decimalPlaces === 0 ? "1" : "0." + "0".repeat(this.decimalPlaces - 1) + "1";
      }

      return null;
    },
    inputMode() {
      return this.type === "amount" || this.decimalPlaces !== null ? "decimal" : null;
    },
    inputClasses() {
      return {
        "text-end": this.type === "amount",
        "pe-1": this.type === "amount",
      };
    },
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
};
</script>

<style scoped>
.soft-field-group {
  position: relative;
}

.soft-field-group.has-password-toggle .form-control {
  padding-right: 2.75rem;
}

.soft-field-toggle {
  position: absolute;
  top: 50%;
  right: 0.85rem;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border: 0;
  padding: 0;
  background: transparent;
  color: var(--bs-secondary-color, #8392ab);
  text-decoration: none;
  z-index: 3;
  line-height: 1;
  box-shadow: none;
  cursor: pointer;
}

.soft-field-toggle:hover,
.soft-field-toggle:focus {
  color: var(--bs-dark, #344767);
  box-shadow: none;
  outline: none;
}

.soft-field-toggle i {
  font-size: 0.95rem;
}
</style>
